import React from "react";

import { ApiUseManagement } from "@components/ApiUse";

export default function ApiUseIndex() {
  return <ApiUseManagement />;
}
